/** @jsx jsx */
import React from 'react';
import { cssMap, jsx } from '@compiled/react';
import { Inline, Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	containerStyle: {
		textDecoration: 'none',
		color: token('color.text'),
		display: 'flex',
		minWidth: '0px',
		width: 'fit-content',
		height: '22px',
		cursor: 'pointer',
		borderRadius: token('radius.small'),
		borderColor: token('color.border'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		backgroundColor: token('elevation.surface'),
		paddingRight: token('space.025'),
		paddingLeft: token('space.050'),
		paddingTop: token('space.025'),
		paddingBottom: token('space.025'),
		alignItems: 'center',
		gap: token('space.075'),
		font: token('font.body'),
		'&:hover': {
			textDecoration: 'underline',
			color: token('color.text'),
		},
		'&:focus': {
			textDecoration: 'underline',
			color: token('color.text'),
		},
	},
	nameStyle: {
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		flex: 1,
		minWidth: '0px',
	},
});

export const AlikeSmartLink = ({ icon, content }: { icon?: React.ReactNode; content: string }) => {
	return (
		<Inline xcss={styles.containerStyle}>
			{icon}
			<Box xcss={styles.nameStyle}>{content}</Box>
		</Inline>
	);
};
